import request from '@teetsh/app/src/utils/request';
import { useState } from 'react';

interface Props {
  file: any;
  onStart: () => void;
  onFinished: () => void;
}

export default async function uploadPicture(props: Props) {
  const { file, onStart, onFinished } = props;

  onStart();

  const requestURL = '/user/upload-picture';
  const formData = new FormData();
  formData.append('file', file);
  const res = await request(requestURL, {
    method: 'POST',
    body: formData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });

  onFinished();
  return res;
}

export function useUploadPicture() {
  const [isUploading, setIsUploading] = useState<boolean>(false);
  const upload = ({ file }: { file: any }) =>
    uploadPicture({
      file,
      onStart: () => setIsUploading(true),
      onFinished: () => setIsUploading(false),
    });

  return {
    upload,
    isUploading,
  };
}
